import * as React from 'react';
import { SVGProps } from 'react';

const ForkKnifeOutlinedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 22"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.63636 2C3.18047 2 2 3.18047 2 4.63636V6.45455C2 7.91044 3.18047 9.09091 4.63636 9.09091C6.09226 9.09091 7.27273 7.91044 7.27273 6.45455V4.63636C7.27273 3.18047 6.09226 2 4.63636 2ZM0 4.63636C0 2.0759 2.0759 0 4.63636 0C7.19683 0 9.27273 2.0759 9.27273 4.63636V6.45455C9.27273 9.01501 7.19683 11.0909 4.63636 11.0909C2.0759 11.0909 0 9.01501 0 6.45455V4.63636Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2727 2.00154C15.8589 2.04946 14.7273 3.21089 14.7273 4.63636V13.6364H17.2727V2.00154ZM12.7273 4.63636C12.7273 2.0759 14.8032 0 17.3637 0H19.2727V15.6364H12.7273V4.63636Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.63635 9.09082V21.9999H3.63635V9.09082H5.63635Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2727 13.6367V22.0004H17.2727V13.6367H19.2727Z"
    />
  </svg>
);

export default ForkKnifeOutlinedIcon;
